var _style, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreateuser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Outline",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M490.7,234.7H448V192c0-11.8-9.6-21.3-21.3-21.3c-11.8,0-21.3,9.6-21.3,21.3v42.7h-42.7 c-11.8,0-21.3,9.6-21.3,21.3c0,11.8,9.6,21.3,21.3,21.3h42.7V320c0,11.8,9.6,21.3,21.3,21.3c11.8,0,21.3-9.6,21.3-21.3v-42.7h42.7 c11.8,0,21.3-9.6,21.3-21.3C512,244.2,502.4,234.7,490.7,234.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M192,256c70.7,0,128-57.3,128-128S262.7,0,192,0S64,57.3,64,128C64.1,198.7,121.3,255.9,192,256z M192,42.7 c47.1,0,85.3,38.2,85.3,85.3s-38.2,85.3-85.3,85.3s-85.3-38.2-85.3-85.3S144.9,42.7,192,42.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M192,298.7c-106,0.1-191.9,86-192,192C0,502.4,9.6,512,21.3,512s21.3-9.6,21.3-21.3 c0-82.5,66.9-149.3,149.3-149.3s149.3,66.9,149.3,149.3c0,11.8,9.6,21.3,21.3,21.3c11.8,0,21.3-9.6,21.3-21.3 C383.9,384.7,298,298.8,192,298.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateuser);
export default __webpack_public_path__ + "static/media/createuser.7c1be7d4219800c9bcc68ff0be378398.svg";
export { ForwardRef as ReactComponent };